import React from "react";
import cn from "clsx";
import classes from "./Footer.module.css";
import Typography from "src/components/ui-kit/Typography";
import Container from "src/components/ui-kit/Container";
import Button from "src/components/ui-kit/Button";
import Partners from "src/components/Partners";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";

interface FooterProps {}

const handleFindAFriendClick = () => {
  trackCustomEvent({
    category: "button",
    action: "g_m_search",
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.ym(53234908, "reachGoal", "y_m_search");
};

const handleInstagramClick = () => {
  trackCustomEvent({
    category: "button",
    action: "g_m_insta",
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.ym(53234908, "reachGoal", "y_m_insta");
};

const Footer: React.FC<FooterProps> = () => (
  <div className={cn(classes.container)}>
    <Container>
      <Typography
        className={cn(classes.gutterBottom)}
        color="inverted"
        variant="h2"
        component="h3"
      >
        <b>Контакты</b>
      </Typography>

      <div className={cn(classes.twoColumn)}>
        <div>
          <Typography
            color="inverted"
            isSemiTransperent
            variant="h3"
            style={{ lineHeight: 1.7 }}
            component="p"
          >
            <b>Координатор</b>
          </Typography>
          <Typography
            className={cn(classes.gutterBottom)}
            variant="h2"
            component="p"
            color="inverted"
          >
            <a href="mailto:ask@fundvet.city">ask@fundvet.city</a>
          </Typography>
          <Button
            href="https://www.instagram.com/vet.city.adoption/"
            color="secondary"
            onClick={handleInstagramClick}
          >
            <img
              src={require("./assets/instagram.svg")}
              alt="Иконка Instagram"
            />
            <Typography variant="h3" component="span" color="inverted">
              @vet.city.adoption
            </Typography>
          </Button>
        </div>
        <div>
          <Typography
            className={cn(classes.gutterBottom)}
            color="inverted"
            variant="h2"
            component="p"
          >
            <b>Дружи, забирай, гладь, люби!</b>
          </Typography>
          <Button
            href="https://fundvet.city/pets"
            color="inverted"
            onClick={handleFindAFriendClick}
          >
            <img src={require("./assets/heart.svg")} alt="Иконка сердечко" />
            <Typography variant="h3" component="span" color="primary">
              НАЙТИ НОВОГО ДРУГА
            </Typography>
          </Button>
        </div>
      </div>
      <div className={cn(classes.bottomLine)}>
        <Partners />
        <Typography color="inverted" className={cn(classes.links)}>
          <b>
            <a href="https://mosmetro.ru/">mosmetro.ru</a>
            <br />
            <a href="https://transport.mos.ru/">transport.mos.ru</a>
          </b>
        </Typography>
      </div>
    </Container>
  </div>
);

export default Footer;
